import React, { useState } from 'react';
function SharedGradeUk() {
    const [originalValue, setOriginalValue] = useState('');
    const [convertedValue, setConvertedValue] = useState('');
    const [studentType, setStudentType] = useState('undergraduate');
    const [conversionType, setConversionType] = useState('grade');
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const calculateGrade = (value) => {
        if (conversionType === 'grade') {
            const grade = parseFloat(value);
            if (!isNaN(grade) && grade >= 0 && grade <= 100) {
                if (studentType === 'undergraduate') {
                    if (grade >= 70) return 'First-Class Honours (First ou 1st)';
                    if (grade >= 60) return 'Upper Second-Class Honours (2:1)';
                    if (grade >= 50) return 'Lower Second-Class Honours (2:2)';
                    if (grade >= 40) return 'Third-Class Honours (Third ou 3rd)';
                    return 'Échec';
                } else if (studentType === 'masters') {
                    if (grade >= 70) return 'Distinction';
                    if (grade >= 60) return 'Merit';
                    if (grade >= 50) return 'Pass';
                    return 'Échec';
                }
            }
        } else if (conversionType === 'gpa') {
            const gpa = parseFloat(value);
            if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
                if (studentType === 'undergraduate') {
                    if (gpa >= 3.9) return 'First-Class Honours (First ou 1st)';
                    if (gpa >= 3.2) return 'Upper Second-Class Honours (2:1)';
                    if (gpa >= 2.6) return 'Lower Second-Class Honours (2:2)';
                    if (gpa >= 1.9) return 'Third-Class Honours (Third ou 3rd)';
                    return 'Échec';
                }
            }
        }
        return 'Entrée invalide';
    };
    const handleCalculateClick = () => {
        const converted = calculateGrade(originalValue);
        setConvertedValue(converted);
        setShowResult(true);
        setError(null);
    };
    const handleConversionTypeChange = (newConversionType) => {
        setConversionType(newConversionType);
        setOriginalValue('');
        setConvertedValue('');
        setShowResult(false);
        setError(null);
    };
    const handleStudentTypeChange = (newStudentType) => {
        setStudentType(newStudentType);
        setOriginalValue('');
        setConvertedValue('');
        setShowResult(false);
        setError(null);
    };
    return (
        <div className='rtl'>
            <div className='row'>
                <div className='col-sm-12 col-md-7 calculatorStyle'>
                    <div className='p-3 mb-2 bg-success text-white'>
                        <h2 style={{ fontSize: '16px' }}>Conversion du système britannique</h2>
                    </div>
                    <hr />
                    <div className='form-group'>
                        <b>
                            <label>Type d'étudiant :</label>
                        </b>
                        <div>
                            <input
                                type='radio'
                                id='undergrad'
                                name='studentType'
                                value='undergraduate'
                                checked={studentType === 'undergraduate'}
                                onChange={() => handleStudentTypeChange('undergraduate')}
                                className='form-check-input'
                                style={{ marginLeft: '4px' }}
                            />
                            <label htmlFor='undergrad' className='form-check-label'>
                                Premier cycle
                            </label>
                        </div>
                        <div>
                            <input
                                type='radio'
                                id='master'
                                name='studentType'
                                value='masters'
                                checked={studentType === 'masters'}
                                onChange={() => handleStudentTypeChange('masters')}
                                className='form-check-input'
                                style={{ marginLeft: '4px' }}
                            />
                            <label htmlFor='master' className='form-check-label'>
                                Master
                            </label>
                        </div>
                    </div>
                    <hr />
                    <div className='form-group'>
                        <b>
                            <label>Type d'entrée :</label>
                        </b>
                        <div>
                            <input
                                type='radio'
                                id='gradeConversion'
                                name='conversionType'
                                value='grade'
                                checked={conversionType === 'grade'}
                                onChange={() => handleConversionTypeChange('grade')}
                                className='form-check-input'
                                style={{ marginLeft: '4px' }}
                            />
                            <label htmlFor='gradeConversion' className='form-check-label'>
                                Pourcentage (100)
                            </label>
                        </div>
                        <div>
                            <input
                                type='radio'
                                id='gpaConversion'
                                name='conversionType'
                                value='gpa'
                                checked={conversionType === 'gpa'}
                                onChange={() => handleConversionTypeChange('gpa')}
                                className='form-check-input'
                                style={{ marginLeft: '4px' }}
                            />
                            <label htmlFor='gpaConversion' className='form-check-label'>
                                GPA (4)
                            </label>
                        </div>
                    </div>
                    <hr />
                    <div className='form-group d-flex align-items-center'>
                        <b>
                            <label htmlFor='originalGrade'>
                                {conversionType === 'grade' ? 'Pourcentage: ' : 'GPA: '}
                            </label>
                        </b>
                        <input
                            type='text'
                            value={originalValue}
                            id='originalGrade'
                            onChange={(e) => setOriginalValue(e.target.value)}
                            className='form-control'
                            style={{ width: '200px', marginRight: '10px' }}
                        />
                    </div>
                    <button className='btn btn-success mt-3' onClick={handleCalculateClick}>
                        Calculer
                    </button>
                    <br />
                </div>
            </div>
            <br />
            <div className='row'>
                <div className='col-sm-12 col-md-7'>
                    {error && (
                        <div className='alert alert-warning'>
                            <b>
                                <u> Erreur :</u>
                            </b>{' '}
                            {error}
                        </div>
                    )}
                    {showResult && (
                        <div style={{ fontSize: '17px' }} className=' bg-light bg-gradient text-dark'>
                            <div className='p-3 bg-success bg-gradient text-white'>
                                <strong>Résultats:</strong>
                            </div>
                            <b>Équivalent britannique: {convertedValue}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default SharedGradeUk;
